import PropTypes from 'prop-types';
import loadable from 'react-loadable';
import Loader from 'components/Loader';
import { SpinnerSize } from '@integration/alexandria-ui';

const delay = 300;

export const Loading = ({ pastDelay }) => {
  if (pastDelay) {
    return <Loader force fullSize blurDepth={SpinnerSize.SMALL} />;
  }
  return null;
};

Loading.propTypes = {
  pastDelay: PropTypes.bool.isRequired,
};

export const CurrentNotification = loadable({
  loading: Loading,
  loader: () => import('containers/CurrentNotification'),
  delay,
});

export const History = loadable({
  loading: Loading,
  loader: () => import('containers/History'),
  delay,
});

export const ReadOnlyHistory = loadable({
  loading: Loading,
  loader: () => import('containers/History/ReadOnlyHistory'),
  delay,
});

export const HelpfulTips = loadable({
  loading: Loading,
  loader: () => import('containers/HelpfulTips'),
  delay,
});

export const FAQPage = loadable({
  loading: Loading,
  loader: () => import('containers/FAQ'),
  delay,
});

export const Case = loadable({
  loading: Loading,
  loader: () => import('containers/Case'),
  delay,
});

export const NotFound = loadable({
  loading: Loading,
  loader: () => import('containers/NotFound'),
  delay,
});

export const Intro = loadable({
  loading: Loading,
  loader: () => import('containers/Intro'),
  delay,
});

export const ScheduleAppointment = loadable({
  loading: Loading,
  loader: () => import('containers/ScheduleAppointment'),
  delay,
});

export const UploadPicturesOpening = loadable({
  loading: Loading,
  loader: () => import('containers/UploadPictures/UploadPicturesOpening'),
  delay,
});

export const UploadPicturesFollowUp = loadable({
  loading: Loading,
  loader: () => import('containers/UploadPictures/UploadPicturesFollowUp'),
  delay,
});

export const Contact = loadable({
  loading: Loading,
  loader: () => import('containers/Contact'),
  delay,
});

export const CaseOpening = loadable({
  loading: Loading,
  loader: () => import('containers/CaseOpening'),
  delay,
});

export const CaseAddress = loadable({
  loading: Loading,
  loader: () => import('containers/CaseAddress'),
  delay,
});

export const CaseIdentification = loadable({
  loading: Loading,
  loader: () => import('containers/CaseIdentification'),
  delay,
});

export const CaseIncidentDescription = loadable({
  loading: Loading,
  loader: () => import('containers/CaseIncidentDescription'),
  delay,
});

export const CaseIncidentInfo = loadable({
  loading: Loading,
  loader: () => import('containers/CaseIncidentInfo'),
  delay,
});

export const CaseVulnerabilitiesDescription = loadable({
  loading: Loading,
  loader: () => import('containers/CaseVulnerabilitiesDescription'),
  delay,
});

export const IncidentDescription = loadable({
  loading: Loading,
  loader: () => import('containers/IncidentDescription/IncidentDescription'),
  delay,
});

export const SynergyIncidentDescription = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyIncidentDescription'),
  delay,
});

export const ContactDetails = loadable({
  loading: Loading,
  loader: () => import('containers/ContactDetails'),
  delay,
});

export const CaseIncidentDate = loadable({
  loading: Loading,
  loader: () => import('containers/CaseIncidentDate/CaseIncidentDate'),
  delay,
});

export const SuccessPage = loadable({
  loading: Loading,
  loader: () => import('containers/Success'),
  delay,
});

export const ErrorPage = loadable({
  loading: Loading,
  loader: () => import('containers/ErrorPage'),
  delay,
});
export const ExcludedPage = loadable({
  loading: Loading,
  loader: () => import('containers/ExcludedPage'),
  delay,
});

export const DropOffPage = loadable({
  loading: Loading,
  loader: () => import('containers/DropOff'),
  delay,
});

export const DropOffSuccessPage = loadable({
  loading: Loading,
  loader: () => import('containers/DropOffSuccess'),
  delay,
});

export const OnGoingPage = loadable({
  loading: Loading,
  loader: () => import('containers/InformationNeeded'),
  delay,
});

export const OnGoingIcvcPage = loadable({
  loading: Loading,
  loader: () => import('containers/InformationNeededIcvc'),
  delay,
});

export const MaintenanceDropOffPage = loadable({
  loading: Loading,
  loader: () => import('containers/DropOffMaintenance'),
  delay,
});

export const SummaryPage = loadable({
  loading: Loading,
  loader: () => import('containers/Summary'),
  delay,
});

export const PreviewPage = loadable({
  loading: Loading,
  loader: () => import('containers/Preview'),
  delay,
});

export const CustomStep = loadable({
  loading: Loading,
  loader: () => import('containers/CaseCustom'),
  delay,
});

export const FlowSelector = loadable({
  loading: Loading,
  loader: () => import('containers/FlowSelector'),
  delay,
});

export const LandingPage = loadable({
  loading: Loading,
  loader: () => import('containers/Landing'),
});

export const CallbackPage = loadable({
  loading: Loading,
  loader: () => import('containers/Callback'),
  delay,
});

export const ConfirmationPage = loadable({
  loading: Loading,
  loader: () => import('containers/Confirmation'),
  delay,
});

export const LocationPage = loadable({
  loading: Loading,
  loader: () => import('containers/Location'),
  delay,
});

export const LocationDetailsMapPage = loadable({
  loading: Loading,
  loader: () => import('containers/LocationDetailsMap'),
  delay,
});

export const ContactUsPage = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyError'),
  delay,
});

export const VehicleDetails = loadable({
  loading: Loading,
  loader: () => import('containers/VehicleDetails'),
  delay,
});

export const SynergyPassengers = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyPassengers'),
  delay,
});

export const FollowMyCase = loadable({
  loading: Loading,
  loader: () => import('containers/FollowMyCase'),
  delay,
});

export const SynergyCaseStatus = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyCaseStatus'),
  delay,
});

export const SynergyContactDetails = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyContactDetails'),
  delay,
});

export const SynergyAdditionalQuestions = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyAdditionalQuestions'),
  delay,
});

export const SynergyDestination = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyDestination'),
  delay,
});

export const SynergyDestinationMap = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyDestinationMap'),
  delay,
});

export const SynergyBookAppointment = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyBookAppointment'),
  delay,
});

export const SynergyConfirmationFollow = loadable({
  loading: Loading,
  loader: () => import('containers/SynergyFollowConfirmation'),
});

export const SynergyIncidentUnderstood = loadable({
  loading: Loading,
  loader: () => import('containers/IncidentUnderstood'),
  delay,
});
